import { canViewModule, getStoredUser, isAdminRole, isPlatformOwnerRole } from './permissionUtils';

export const filterMenuByPermission = (menuList) => {
  const user = getStoredUser();

  if (!user) return [];

  // Platform Owner sees ONLY Manage Restaurants — nothing about any single
  // restaurant's own data is relevant to this role.
  if (isPlatformOwnerRole(user)) {
    return menuList.filter((item) => item.module_key === 'manage_restaurants');
  }

  if (isAdminRole(user.role)) {
    return menuList.filter((item) => item.module_key !== 'manage_restaurants');
  }

  return menuList
    .map((item) => {
      if (item.children?.length) {
        const filteredChildren = item.children.filter((child) =>
          canViewModule(child.module_key)
        );

        if (filteredChildren.length > 0) {
          return {
            ...item,
            children: filteredChildren,
          };
        }

        return null;
      }

      if (!item.module_key) return item;

      return canViewModule(item.module_key) ? item : null;
    })
    .filter(Boolean);
};